module.exports = __webpack_public_path__ + "media/images/version_merge/raffle_promotion-unsuccess-ab40c90512873b3e854716da321c391d.jpg";